import type { PageTabName } from '@coursera/event-pulse-types';

export const ProgrammingAssignmentsSubViews = {
  DEFAULT: 'instructions',
  INSTRUCTIONS: 'instructions',
  SUBMISSIONS: 'submission',
  DISCUSSIONS: 'programming.discussions', // This needs to be different than "discussions" or else there's an invariant violation ¯\_(ツ)_/¯
  SHARING: 'sharing',
} as const;

export type ProgrammingAssignmentsSubView =
  (typeof ProgrammingAssignmentsSubViews)[keyof typeof ProgrammingAssignmentsSubViews];

// These type mappings are relics of earlier decisions, and these differences exist only in FE code (all UX references should use "web"/"script"/"lab")
// We've decided to keep these references in FE code because of the low reward and high risk and effort associated with making schema and eventing changes
export const LearnerProgrammingSubmissionTypeNames = {
  WEB: 'files',
  SCRIPT: 'script',
  LAB: 'workspace',
} as const;

export type LearnerProgrammingSubmissionTypeName =
  (typeof LearnerProgrammingSubmissionTypeNames)[keyof typeof LearnerProgrammingSubmissionTypeNames];

export type PageTabNameEventTypes = Extract<
  PageTabName,
  | 'sharing'
  | 'instructions'
  | 'programming_discussions'
  | 'submission'
  | 'submission_script'
  | 'submission_files'
  | 'submission_workspace'
>;
